import { useEffect, useState } from 'react';
import { usePrefersReducedMotion } from '../../hooks/usePrefersReducedMotion';
import { ACCENT, FONT_MONO, MUTED, TEXT_PRIMARY } from '../../tokens';

const FEED_MSGS: readonly string[] = [
  'Scanning competitor comments for unanswered questions...',
  'New objection logged, pricing, 4th time this month...',
  'Drafting hook, reframe, proof, CTA in your voice...',
  'Meta ad queued, cut from last week top post...',
  'Review request sent, job marked complete...',
  'Weekly report ready, 3 posts outperformed the baseline...',
];

/** Faked live activity feed, typed out one character at a time. */
export function TypewriterCard() {
  const reduced = usePrefersReducedMotion();
  const [text, setText] = useState(reduced ? (FEED_MSGS[0] ?? '') : '');
  const [msgIndex, setMsgIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (reduced) return;

    const msg = FEED_MSGS[msgIndex] ?? '';

    if (charIndex <= msg.length) {
      const timer = setTimeout(
        () => {
          setText(msg.slice(0, charIndex));
          setCharIndex((c) => c + 1);
        },
        charIndex === 0 ? 500 : 40,
      );
      return () => clearTimeout(timer);
    }

    // Message finished — hold, then advance to the next one.
    const timer = setTimeout(() => {
      setMsgIndex((m) => (m + 1) % FEED_MSGS.length);
      setCharIndex(0);
    }, 1800);
    return () => clearTimeout(timer);
  }, [charIndex, msgIndex, reduced]);

  return (
    <div style={{ marginTop: 8, minHeight: 100 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
        <div
          style={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            background: '#22c55e',
            animation: 'pulse-dot 2s ease-in-out infinite',
            flexShrink: 0,
          }}
        />
        <span style={{ fontFamily: FONT_MONO, fontSize: '0.62rem', color: MUTED, letterSpacing: '0.1em' }}>
          LIVE FEED, THE PRE-SOLD OS
        </span>
      </div>
      <div style={{ fontFamily: FONT_MONO, fontSize: '0.85rem', color: TEXT_PRIMARY, lineHeight: 1.7 }}>
        <span style={{ color: ACCENT, marginRight: 4 }}>▶</span>
        {text}
        <span
          style={{
            display: 'inline-block',
            width: 2,
            height: '0.9em',
            background: ACCENT,
            marginLeft: 2,
            verticalAlign: 'middle',
            animation: 'blink 1.1s step-end infinite',
          }}
        />
      </div>
    </div>
  );
}
